//@ts-check
import React, { useEffect, useState } from "react";
import StudyForList from "../../../models/studies/list";
import { uploadInform } from "../../../utils/uploadInform";

/**
 * @param {Object} props
 * @param {boolean} props.activo
 * @param {StudyForList} props.paciente
 * @param {function} props.CerrarDialog
 */
const Upload = (props) => {
  const [Informe, setInforme] = useState(
    /** @type {{ listo: boolean; blob: File; }} */ ({ listo: false, blob: {} }),
  );
  const [mensajeBoton, setmensajeBoton] = useState("Cargar Informe");
  let CargarInformeClick = () => {
    document.getElementById("Informeupload")?.click();
  };
  /**
   *
   * @param {*} e
   */
  let cargararchivo = (e) => {
    setInforme({ listo: true, blob: e.target.files[0] });
  };
  /**
   *
   * @param {*} e
   */
  let drag = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  /**
   *
   * @param {*} e
   */
  let drop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer.files[0].type === "application/pdf") {
      setInforme({ listo: true, blob: e.dataTransfer.files[0] });
    } else {
      alert("El archivo no es PDF");
    }
  };
  let send = async () => {
    setInforme({ ...Informe, listo: false });
    setmensajeBoton("Cargando...");
    const status = await uploadInform(Informe.blob, props.paciente);
    setmensajeBoton("Cargar Informe");
    if (status) {
      alert("Informe cargado correctamente");
    } else {
      alert("Error al cargar el informe");
    }
    // @ts-ignore
    setInforme({ listo: false, blob: {} });
  };
  useEffect(() => {
    return () => {
      // @ts-ignore
      setInforme({ listo: false, blob: {} });
    };
  }, []);
  return (
    <div className="Upload">
      <div className="Upload1">
        <div
          className="Upload11"
          onClick={CargarInformeClick}
          onDragOver={drag}
          onDrop={drop}
        >
          {Informe.blob.name === undefined
            ? `Arrastrar o click para cargar el informe`
            : Informe.blob.name}
        </div>
        <input
          type="file"
          id="Informeupload"
          onChange={cargararchivo}
          accept="application/pdf"
        />
      </div>
      <div className="Upload2">
        <button
          disabled={!Informe.listo}
          className="Boton"
          value={Informe.blob.name}
          onClick={send}
        >
          {mensajeBoton}
        </button>
      </div>
    </div>
  );
};

export default Upload;
